import Promise from "bluebird"
import Vue from 'vue'
import axios from 'axios';
import VueLocalStorage from "vue-localstorage"

Vue.use(VueLocalStorage, {
  name: 'context',
  bind: true //created computed members from your variable declarations
})

class HttpService {
  
  static get(url) {
    if (this.requestExists(url)) return Promise.resolve(this.getRequest(url)) 
    return Promise.resolve(axios.get(url))
      .tap(res => this.storeRequest(url, res.data))
  }
  
  static storeRequest(url, data) {
    const http = JSON.parse(Vue.context.get('http')) || {}
    _.set(http, _.kebabCase(url), data)
    Vue.context.set('http', JSON.stringify(http))
  }

  static getRequest(url) {
    const http = JSON.parse(Vue.context.get('http'))
    return {data: _.get(http, _.kebabCase(url))}
  }
  
  static requestExists(url) {
    const http = Vue.context.get('http')
    return _.includes (http, _.kebabCase(url))
  }

}

export default HttpService

export {HttpService}